import EFPicture from 'elem/compCommon/EFPicture';
import SolarPanel from '@elem/SVGIcon/CostSaving/SolarPanel';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Capacity from '@elem/SVGIcon/CostSaving/Capacity';
import Installation from '@elem/SVGIcon/CostSaving/Installation';

export default function WholeHome() {
    const { useLang } = useGlobal();
    const { t } = useLang('costsaving');
    const icons: any = [
        {
            icon: <SolarPanel />,
            text: t('whole_home_icon3'),
        },
        {
            icon: <Capacity />,
            text: t('whole_home_icon1'),
        },
        {
            icon: <Installation />,
            text: t('whole_home_icon2'),
        },
    ];
    return (
        <div className={styles.wholehome} id="wholeHome">
            <div className="content-box">
                <div className="img-box">
                    <EFPicture
                        src={'https://websiteoss.ecoflow.com/upload/image/1749020494850/wholeHome_pc.jpg'}
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1749104753668/wholeHome_pad.jpg"
                        srcMobile={'https://websiteoss.ecoflow.com/upload/image/1749104753389/wholeHome_h5.jpg'}
                        alt={t('secC_title')}
                    />
                </div>
                <div className="text-info">
                    <h2 className="title white">{t('whole_home_title')}</h2>
                    <p className="desc s">{t('whole_home_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text li">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
